"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var GridContainer = /** @class */ (function (_super) {
    __extends(GridContainer, _super);
    function GridContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.bindAll();
        return _this;
    }
    GridContainer.prototype.bindAll = function () {
        this.onClick = this.onClick.bind(this);
    };
    GridContainer.prototype.render = function () {
        var classes = [this.containerClasses(this.props.options), this.customClasses(this.props.options)];
        var customOptions = (this.props.options && this.props.options.customOptions) ?
            this.props.options.customOptions : {};
        return (React.createElement("div", __assign({ "data-test-id": this.props.testId, className: classes.join(' '), onClick: this.props.events && this.props.events.onClick ? this.onClick : null }, customOptions), this.props.children));
    };
    GridContainer.prototype.containerClasses = function (options) {
        if (options && options.fullWidth) {
            return 'full-width-container';
        }
        else if (options && options.wideGrid) {
            return 'wide-grid';
        }
        else {
            return 'container';
        }
    };
    GridContainer.prototype.customClasses = function (options) {
        if (options && options.className) {
            return options.className;
        }
        else {
            return '';
        }
    };
    GridContainer.prototype.onClick = function () {
        if (this.props.events && this.props.events.onClick) {
            return this.props.events.onClick();
        }
    };
    return GridContainer;
}(React.Component));
exports.default = GridContainer;
//# sourceMappingURL=GridContainer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Grid/GridContainer/GridContainer.js
// module id = 1359
// module chunks = 8